const collections = document.querySelectorAll('.teaser-tile-items--collection .neos-contentcollection')

if (collections.length > 0) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return

      const children = entry.target.children
      Array.from(children).forEach((child, index) => {
        child.style.transitionDelay = `${index * 100}ms`
      })

      entry.target.classList.add('animate-in')
      observer.unobserve(entry.target)
    })
  }, { threshold: 0.5 })

  collections.forEach(collection => {
    observer.observe(collection)
  })
}
